/* global $ */
import { createElement, Component, PropTypes } from 'rlink-react';
import themeable from 'rlink-theme/themeable';

import studioScene from 'helpers/scenes/studioScene';
import Picture from 'rlink-repos/components/Picture';

const sliderSettings = {
  autoplay: false,
  autoplaySpeed: 4000,
  arrows: false,
  dots: true,
  respondTo: '#slider',
};

export default class StudioSection extends Component {
  componentDidMount () {
    $('#StudioSlider').slick(sliderSettings);
    $(window).on('slider-start', () => {
      $('#StudioSlider').slick('slickPlay');
    });
    $(window).on('slider-stop', () => {
      $('#StudioSlider').slick('slickPause');
    });
    studioScene();
  }

  render () {
    let {theme, studioSliderData} = this.props;
    return (
      <div>
        <article id="studio" className="layout-text bg-white text-black clearfix">
          <div className="wrapper">
            <div className="row">
              <h2>The Studio</h2>
              <div>
                <p>We are an award-winning developer of genre-defining real-time strategy games like Homeworld, Dawn of
            War, Company of Heroes and many more. Throughout our storied 17-year history, delivering rich, thoughtful
            strategy games has always been our defining quality.</p>
                <p>In essence, we envision the type of games that we would love to play, and then we create them.</p>
                <p>Our studio is different from most others. We value ideas and innovation so every game we create is
            a true reflection of our entire teams’ capabilities. We believe in the autonomous, entrepreneurial
            spirit of an indie developer – only with the extensive resources of a large publisher.</p>
                <p>We are owned by SEGA, a world leader in interactive entertainment. They provide us with the autonomy
            and creative control needed to preserve the integrity of the gaming experience, from the concept
            stage right through to final development. Being part of the SEGA family also gives us access to resources
            and talent that will help us build on our legacy of innovation.</p>
              </div>
            </div>
          </div>
        </article>
        <article id="slider" className="layout-text bg-white clearfix">
          <p />
          <div className="wrapper">
            <div className="row">
              <div id="StudioSlider" className={`slider ${theme.StudioSlider}`}>
                {studioSliderData
                  .sort((a, b) => Number.parseInt(a.priority) - Number.parseInt(b.priority))
                  .map(item => (
                    item.mainImageFormats.src !== '' && (
                      <div key={`studioSlider-${item.mainImageFormats.src}`}>
                        <Picture
                          src={item.mainImageFormats.src}
                          widths={item.mainImageFormats.widths}
                          heights={item.mainImageFormats.heights}
                          formats={item.mainImageFormats.formats} />
                      </div>
                    )
                  ))}
              </div>
            </div>
          </div>
        </article>
      </div>
    );
  }
}

StudioSection.propTypes = {
  studioSliderData: PropTypes.arrayOf(PropTypes.shape({
    mainImageFormats: PropTypes.shape({
      src: PropTypes.string,
      widths: PropTypes.arrayOf(PropTypes.number),
      heights: PropTypes.arrayOf(PropTypes.number),
      formats: PropTypes.arrayOf(PropTypes.shape({
        contentType: PropTypes.string,
        fileExt: PropTypes.string,
      })),
    }),
    title: PropTypes.string,
    priority: PropTypes.number,
  })),
};

themeable(StudioSection, {
  classes: [
    'StudioSlider',
  ],
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/AboutUs/StudioSection.jsx